import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Xls"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 17.25H16.5V15.75H21V12.75H18C17.1719 12.7492 16.5008 12.0781 16.5 11.25V8.25C16.5008 7.42192 17.1719 6.75083 18 6.75H22.5V8.25H18V11.25H21C21.8281 11.2508 22.4992 11.9219 22.5 12.75V15.75C22.4992 16.5781 21.8281 17.2492 21 17.25ZM10.5 15.75V6.75H9V17.25H15V15.75H10.5ZM7.5 6.75H6L4.5 11.25L3 6.75H1.5L3.564 12L1.5 17.25H3L4.5 12.75L6 17.25H7.5L5.43375 12L7.5 6.75Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Xls.vue"]]);
